import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installation-layout',
  templateUrl: './installation-layout.component.html',
  styleUrls: ['./installation-layout.component.scss']
})
export class InstallationLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
